// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"1963d242","520":"dc9fcd40","636":"f8139331","787":"96d091b9","837":"b4751bdb"}[chunkId] + ".chunk.js";
};